import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

class ImageCarousel {
  constructor(el) {
    this.el = el;
    this.fullWidth = el.classList.contains('full-width');
    this.autoplay = el.dataset.autoplay;
  }

  init() {
    const swiperArgs = {
      slidesPerView: 1,
      loop: true,
      allowTouchMove: true,
      centeredSlides: false,
      spaceBetween: 12,
      modules: [],
    };

    if (this.autoplay) {
      swiperArgs.modules.push(Autoplay);
      swiperArgs.autoplay = {
        delay: 5000,
      };
    }

    if (this.fullWidth) {
      swiperArgs.centeredSlides = true;
      swiperArgs.modules.push(Pagination);
      swiperArgs.pagination = {
        el: '.swiper-pagination',
        clickable: true,
      };
    } else {
      swiperArgs.modules.push(Navigation);

      swiperArgs.navigation = {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      };

      swiperArgs.breakpoints = {
        768: {
          slidesPerView: this.fullWidth ? 1 : 3,
        },
      };
    }

    const slider = new Swiper(this.el, swiperArgs);

    this.slider = slider;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const imageCarousels = document.querySelectorAll('.image-carousel .swiper');

  imageCarousels.forEach((el) => {
    new ImageCarousel(el).init();
  });
});
